import strategyIconAlpha10 from "assets/images/aicopy/eb3a5f42-0255-4b85-82c6-bd5462a3928b.png";
import {
  formatAicopyCouponExpireDateTime,
  isAicopyCouponPosition,
  parseCouponExpireTimeMs,
} from "./couponPositionFields";
import { formatAicopySymbolForDisplay } from "./formatAicopySymbolForDisplay";

function formatNumber(num) {
  if (!num && num !== 0) return "0";
  const numStr = typeof num === "string" ? num : num.toString();
  const parts = numStr.split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}

function formatDisplayDateTime(timestamp) {
  if (timestamp === undefined || timestamp === null || timestamp === "") return "";
  const ts = Number(timestamp);
  if (Number.isNaN(ts)) return "";
  const date = new Date(ts);
  if (Number.isNaN(date.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${date.getFullYear()}/${pad(date.getMonth() + 1)}/${pad(date.getDate())} ${pad(date.getHours())}:${pad(
    date.getMinutes()
  )}:${pad(date.getSeconds())}`;
}

function formatReturnRatePercent(raw) {
  if (raw == null || raw === "") return "0.00%";
  const n = parseFloat(String(raw).replace(/,/g, ""));
  if (!Number.isFinite(n)) return "0.00%";
  const pct = Math.abs(n) <= 1 && !String(raw).includes("%") ? n * 100 : n;
  return (pct >= 0 ? "+" : "") + pct.toFixed(2) + "%";
}

function formatProfitAmount(raw) {
  const n = parseFloat(String(raw ?? "").replace(/,/g, ""));
  if (!Number.isFinite(n)) return "0";
  const absStr = formatNumber(String(Math.abs(n)));
  if (n > 0) return `+${absStr}`;
  if (n < 0) return `-${absStr}`;
  return absStr;
}

function resolveHistoryTags(item, t) {
  const tags = Array.isArray(item.tags) ? item.tags.filter(Boolean) : [];
  if (tags.length > 0) return tags;

  const built = [];
  if (item.direction) {
    built.push(item.direction === "LONG" ? t("aicopy.long") : t("aicopy.short"));
  }
  if (item.leverage != null && item.leverage !== "") {
    built.push(`${item.leverage}X`);
  }
  return built;
}

/**
 * my/history-positions（及兼容 my/history）列表项 → 订单历史卡片展示结构
 */
export function mapAicopyHistoryOrderItem(item, t) {
  const tags = resolveHistoryTags(item, t);
  const tag = tags[0] || "";
  const tagType = tags.some(
    (x) => String(x).toLowerCase().includes("top") || String(x).toLowerCase().includes("trader")
  )
    ? "topTrader"
    : "tactics";

  const isCouponPosition = isAicopyCouponPosition(item);
  const couponExpireMs = isCouponPosition ? parseCouponExpireTimeMs(item) : null;

  const strategyName =
    item.strategyName ||
    item.strategy_name ||
    (item.symbol ? formatAicopySymbolForDisplay(item.symbol).pairLabel : "") ||
    "—";

  const profitRaw = item.profit ?? item.pnlAmount ?? item.netProfit ?? item.followerPnl ?? "0";
  const returnRateRaw = item.pnlRate;

  const startTs = item.startTime ?? item.start_time ?? item.openTime ?? item.open_time;
  const endTs = item.endTime ?? item.end_time ?? item.closeTime ?? item.close_time;

  let followDays = item.followDays ?? item.follow_days;
  if (followDays == null && startTs && endTs) {
    const start = Number(startTs);
    const end = Number(endTs);
    if (Number.isFinite(start) && Number.isFinite(end) && end >= start) {
      followDays = Math.max(1, Math.ceil((end - start) / (24 * 60 * 60 * 1000)));
    }
  }

  return {
    isCouponPosition,
    couponExpireMs,
    id: item.positionId ?? item.id,
    strategyId: item.strategyId ?? item.strategy_id,
    strategyName,
    avatarUrl: item.avatarUrl ?? item.avatar_url ?? strategyIconAlpha10,
    tag,
    tagType,
    totalInvestAmount:
      item.totalInvestAmount ??
      item.total_invest_amount ??
      item.investAmount ??
      item.invest_amount ??
      "0.00",
    totalReturnRate: formatReturnRatePercent(returnRateRaw),
    profit: formatProfitAmount(profitRaw),
    startTime: formatDisplayDateTime(startTs),
    endTime: formatDisplayDateTime(endTs),
    followDays: followDays != null && followDays !== "" ? `${followDays}${t("aicopy.days")}` : "",
    voucherExpireTime: couponExpireMs != null ? formatAicopyCouponExpireDateTime(couponExpireMs) : "",
  };
}
